import { useTranslation } from "react-i18next";
import ToolbarGrid from "../Components/Table";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  triggerMultiDeleteModal,
} from "../../Podcast/utils/action";
import { useEffect, useState } from "react";
import { setSearchKeyWord, setFilter } from "../utils/action";
import "../../index.css";
import "./podcast.scss";
import { Dialog, DialogContent } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { ClipLoader } from "@empreinte/components.clip-loader";
import LoadingScreen from "../utils/LoadingScreen";
import i18next from "i18next";
import { useHistory } from "react-router-dom";
import MediaNotfound from "../../MediaNotfound";
import { SearchBar } from "@empreinte/components.search-bar";
import { Header } from "@empreinte/components.header";
import { ModalConfirm } from "@empreinte/components.modal-confirm";
import { SelectList } from "@empreinte/components.select-list";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Hooks from "../utils/hooks";
import { PodcastGraphQlFetchData } from "../graph-ql-podcast/GraphQlFetchData";
import { TYPES } from "../utils/types";
import AddIcon from "@mui/icons-material/Add";

const Podcast = () => {
  const { GETPODCASTLIST } = PodcastGraphQlFetchData();
  const { DeleteMultiplePodcasts, ArchivePodcasts } = Hooks();
  const onDeleteGroup = useSelector(
    (state) => state.ReducerGetPodcastData.onDelete
  );
  const MultiDeleteId = useSelector(
    (state) => state.ReducerGetPodcastData.MultiDeleteId
  );
  const deletePodcastData = useSelector(
    (state) => state.ReducerGetPodcastData.deletePodcastData
  );
  const singlePodcastDelete = useSelector(
    (state) => state.ReducerGetPodcastData.singlePodcastDelete
  );
  const editedPodcast = useSelector(
    (state) => state.ReducerGetPodcastData.isPodcastEdited
  );
  const addedPodcast = useSelector(
    (state) => state.ReducerGetPodcastData.isPodcastAdded
  );
  const isDeleted = useSelector(
    (state) => state.ReducerGetPodcastData.isDeleted
  );
  const doneDelete = useSelector(
    (state) => state.ReducerGetPodcastData.doneDelete
  );
  const modules = useSelector((state) => state.ReducerUserData.modules);
  const isSuperAdmin = useSelector(
    (state) => state.ReducerUserData.isSuperAdmin
  );
  const downloadmodal = useSelector(
    (state) => state.ReducerGetPodcastData.success_download
  );
  const loadingscreen = useSelector(
    (state) => state.ReducerGetPodcastData.on_loading_screen
  );

  const loading = useSelector((state) => state.ReducerUserData.loading);

  const unautorizedPodcast = useSelector(
    (state) => state.ReducerGetPodcastData.unauthorizedPodcast
  );

  const unauthorizedUser = useSelector(
    (state) => state.ReducerUserData.unauthorizedUser
  );
  const FilterList = useSelector(
    (state) => state.ReducerGetPodcastData.FilterList
  );
  const [SearchWord, setSearchWord] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const history = useHistory();
  const { t } = useTranslation();
  const [Filter, setFilterValue] = useState(FilterList);
  const [offset, setOffset] = useState(0)
  const [searchWorld, setSearchWorld] = useState("");

  useEffect(() => {
    if (isDeleted) {
      dispatch({ type: TYPES.is_Deleted, payload: false });
    }else if(doneDelete) {
      dispatch({ type: TYPES.done_Delete, payload: false });
    }
	// eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDeleted, doneDelete, dispatch]);
const [pagination, setPagination] = useState(false);

 const handlePageChange = (page) => {
		setCurrentPage(page);
		setPagination(true);
 };
const handlePageSizeChange = (size) => {
	setPageSize(size);
};


  useEffect(() => {
    if (
			pagination === true ||
			searchWorld === "" ||
			editedPodcast ||
			addedPodcast ||
			onDeleteGroup ||
			deletePodcastData ||
			singlePodcastDelete
		) {
			const offset = (currentPage - 1) * pageSize;
			setOffset(offset);
			GETPODCASTLIST({
				variables: {
					where: {
						isArchived: Filter==="trash" ? true : false,
						...(Filter!=="trash" && {isOffline:Filter==="offline"?true:false}),
						...(searchWorld && { titleContains: searchWorld }),
					},
					pagination: { limit: pageSize, offset },
					orderBy: { direction: "DESC" },
				},
			});
		}
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    
    pageSize,
    currentPage,
    Filter,
    editedPodcast,
    addedPodcast,
    onDeleteGroup,
    deletePodcastData,
    singlePodcastDelete,
    
  ]);


  useEffect(() => {
    const language = localStorage.getItem("lang");
    if (language === "null") {
      i18next.changeLanguage("fr");
      localStorage.setItem("lang", "fr");
    }
    window.addEventListener("message", function (event) {
      if (event.data?.info === "updateLang") {
        i18next.changeLanguage(event.data.lang);
        localStorage.setItem("lang", event.data.lang);
      }
      if (event.data?.info === "redirectHomepage") {
        history.push("/ws-media/podcasts");
      }
    });
	// eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (event) => {
    setFilterValue(event.target.value);
    dispatch(setFilter(event.target.value));
    setCurrentPage(1)
  };


	const handleMultiDelete = async () => {
	
		try {
			if (Filter!=="trash") {
				await DeleteMultiplePodcasts(MultiDeleteId);
				GETPODCASTLIST({
					variables: {
						where: { isArchived: false,isOffline:Filter==="offline"?true:false },
						pagination: { limit: pageSize, offset: 0 },
						orderBy: { direction: "DESC" },
					},
				});
			} else {
				await ArchivePodcasts(MultiDeleteId);
				setCurrentPage(1);
				GETPODCASTLIST({
					variables: {
						where: { isArchived: true },
						pagination: { limit: pageSize, offset: 0 },
						orderBy: { direction: "DESC" },
					},
				});
			}

			handleClose();
		} catch (error) {
			console.error("Erreur lors de la suppression ou de l'archivage des podcasts :", error);
		}
	};


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };




  if (loadingscreen || loading) {
    return <LoadingScreen />;
  } else if (unautorizedPodcast || unauthorizedUser) {
    return <MediaNotfound />;
  }
   

const handleKeyDown = (e) => {
	if (e.key === "Enter") {
     setPagination(false);
		setSearchWorld(e.target.value);
    setOffset(0);
		setCurrentPage(1);

    if(pagination === false) {
			GETPODCASTLIST({
				variables: {
					where: {
						isArchived: Filter==="trash" ? true : false,
						...(Filter && Filter!=="trash" && {isOffline:Filter==="offline"?true:false}),
						...(e.target.value.trim()
						? isNaN(e.target.value)
								? { titleContains: e.target.value.trim() }
								: {
									or: [
											{ id: e.target.value.trim() },
											{ titleContains: e.target.value.trim() },
									],
							}
				: {}),
					},
					pagination: { limit: pageSize, offset },
					orderBy: { direction: "DESC" },
				},
		});
    } 

	 
	}
};



  return (
		<div className="containerPodcast">
			<Header
				className="header_title"
				firstBtnTitle={t("Podcast.Add")}
				title="Podcast"
				onMainPage={true}
				hasPermission={"podcast_post_add"}
				mainPageBtnAction={() => {
					history.push("/podcast/upload");
				}}
				firstBtnIcon={<AddIcon />}
			/>
			<div className="sous-header">
				<div className={onDeleteGroup ? "onDelete" : null}>
					{onDeleteGroup && MultiDeleteId.length > 0 ? (
						<div className="messageDelete">
							<DeleteIcon
								onClick={() => {
									handleClickOpen();
									dispatch(triggerMultiDeleteModal());
								}}
								sx={{ marginLeft: "0.8%", cursor: "pointer", color: "black" }}
							/>
							<div className="suppTextPodcats">
								{MultiDeleteId.length} {t("élément(s) sélectionné(s)")}
							</div>
						</div>
					) : null}

					{/* MultiDelete Modal */}
					{doneDelete ? null : (
						<>
							{" "}
							{isDeleted ? (
								<Dialog
									open={open}
									onClose={handleClose}
									aria-labelledby="alert-dialog-title"
									aria-describedby="alert-dialog-description"
								>
									<DialogContent sx={{ height: "50%" }}>
										<ClipLoader color="inherit" thickness={1.6} style={{ marginTop: "6px" }} />
									</DialogContent>
								</Dialog>
							) : (
								<>
									<ModalConfirm
										open={open}
										fullWidth={true}
										className="confirm-modal-delete"
										onClose={handleClose}
										aria-labelledby="alert-dialog-title"
										aria-describedby="alert-dialog-description"
										title={t("Podcast.Are you sure you want to delete the selected podcasts ?")}
										content={t("Podcast.add-edit.Selected items will be deleted")}
										CancelBtnName={t("Podcast.add-edit.cancel")}
										onCancel={() => {
											handleClose();
										}}
										ConfirmBtnName={t("Podcast.add-edit.Confirm")}
										onConfirm={handleMultiDelete}
									/>
								</>
							)}
						</>
					)}
					{downloadmodal ? (
						<Dialog
							open={true}
							aria-labelledby="alert-dialog-title"
							aria-describedby="alert-dialog-description"
						>
							<DialogContent sx={{ height: "50%" }}>
								<ClipLoader color="inherit" thickness={1.6} style={{ marginTop: "6px" }} />
							</DialogContent>
						</Dialog>
					) : null}

					{/*  */}
					<div
						className={onDeleteGroup ? "searchBarOnDelete"
									: "searchBar"
						}
					>
						<div className="shadowShouldBeADDED">
							<Box sx={{ minWidth: 250 }}>
								<FormControl fullWidth>
									<SelectList
										className="home-select-podcast"
										labelId="demo-simple-select-label"
										id="demo-simple-select"
										value={Filter}
										handleChange={handleChange}
										data={[
											{ value: "online", label: t("Podcast.online") },
											{ value: "offline", label: t("Podcast.offline") },
											{ value: "trash", label: t("Podcast.trash") },
									]}
									/>
								</FormControl>
							</Box>
						</div>
						<div className="shadowShouldBeADDED widthFullForPodcastSearch">
							<SearchBar
								onCancelSearch={() => dispatch(setSearchKeyWord(""))}
								name="SearchWord"
								value={SearchWord}
								setSearchText={(e) => setSearchWord(e.target.value)}
								className="searchComponent"
								placeholder={t("Podcast.Search...")}
								onKeyDown={handleKeyDown}
							/>
						</div>
					</div>
				</div>
				{(modules?.podcast_list_dtable || isSuperAdmin) && (
					<div className="data-table" has-permission="podcast_list_dtable">
						<ToolbarGrid
							setCurrentPage={handlePageChange}
							currentPage={currentPage}
							setPageSize={handlePageSizeChange}
							pageSize={pageSize}
						/>
					</div>
				)}{" "}
			</div>
		</div>
	);
};

export default Podcast;
